import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5da59348"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "container" }
const _hoisted_2 = { id: "icon" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Sign in with Google ")

import GoogleLogo from '@/components/icons/GoogleLogo.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// Somehow applying styles directly to this component doesn't work,so it's wrapped in a div

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(GoogleLogo)
    ]),
    _hoisted_3
  ]))
}
}

})